import { render, staticRenderFns } from "./ReviewsAnalystRatingsChartLegendItem.vue?vue&type=template&id=67e8279f&scoped=true&"
import script from "./ReviewsAnalystRatingsChartLegendItem.vue?vue&type=script&lang=js&"
export * from "./ReviewsAnalystRatingsChartLegendItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAnalystRatingsChartLegendItem.vue?vue&type=style&index=0&id=67e8279f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8279f",
  null
  
)

export default component.exports